export const Abort = Symbol('abort')

export const Iterator = String(Symbol.iterator)
